module.exports = __webpack_public_path__ + "static/media/vhi.a2337eac.png";